import { User } from 'firebase/auth';
import React, { useEffect, useState } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { auth } from '../../shared/firebase/firebase';

const AuthGuard: React.FC = () => {
  const [loading, setLoading] = useState<boolean>(true);
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
  const location = useLocation();

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (user: User | null) => {
      setIsAuthenticated(!!user); // Проверяем, авторизован ли пользователь
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!isAuthenticated) {
    // Forward the query string too, so e.g. /?mode=demo still reaches AuthPage's
    // auto-demo trigger instead of being dropped on redirect.
    return <Navigate to={{ pathname: '/auth', search: location.search }} replace />;
  }

  return <Outlet />;
};

export default AuthGuard;
